import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';

Vue.use(Router);

export const router = new Router({
    mode: 'history',
    base: window.BASE,
    routes: [
        {
            path: '/',
            name: 'login',
            meta: {
                title: 'Logowanie',
                allowed: ['public']
            },
            component: Login,
        },
        {
            path: '/login',
            meta: {
                title: 'Logowanie',
                allowed: ['public']
            },
            component: Login
        },
        {
            path: '/website/:dbid/:token',
            meta: {
                title: 'Autoryzacja',
                allowed: ['public']
            },
            component: () => import('./views/WebsiteAuth.vue')
        },
        {
            path: '/profile',
            name: 'profile',
            meta: {
                title: 'Twój profil',
                allowed: ['premium', 'admin']
            },
            component: () => import('./views/Profile.vue')
        },
        {
            path: '/manage-group',
            name: 'manageGroup',
            meta: {
                title: 'Grupa',
                allowed: ['premium']
            },
            component: () => import('./views/ManageGroup.vue')
        },
        {
            path: '/clients',
            name: 'clients',
            meta: {
                title: 'Klienci',
                allowed: ['premium']
            },
            component: () => import('./views/Clients.vue')
        },
        {
            path: '/access',
            name: 'access',
            meta: {
                title: 'Dostęp do panelu',
                allowed: ['premiumOwner']
            },
            component: () => import('./views/Access.vue')
        },
        {
            path: '/manage-channels',
            name: 'manageChannels',
            meta: {
                title: 'Kanały',
                allowed: ['premium']
            },
            component: () => import('./views/ManageChannels.vue')
        },
        {
            path: '/admin',
            name: 'admin',
            meta: {
                title: 'Administrator',
                allowed: ['admin']
            },
            component: () => import('./views/Admin.vue')
        },
        {
            path: '/admin-manage',
            name: 'adminManage',
            meta: {
                title: 'Administrator Zarządzanie',
                allowed: ['admin']
            },
            component: () => import('./views/AdminManage.vue'),
            children: [
                {
                    path: ':id/manage-group',
                    name: 'adminManage-manageGroup',
                    meta: {
                        title: 'Admin - Grupa',
                        allowed: ['admin'],
                        adminManage: true
                    },
                    component: () => import('./views/ManageGroup.vue')
                },
                {
                    path: ':id/clients',
                    name: 'adminManage-clients',
                    meta: {
                        title: 'Admin - Klienci',
                        allowed: ['admin'],
                        adminManage: true
                    },
                    component: () => import('./views/Clients.vue')
                },
                {
                    path: ':id/manage-channels',
                    name: 'adminManage-manageChannels',
                    meta: {
                        title: 'Admin - Kanały',
                        allowed: ['admin'],
                        adminManage: true
                    },
                    component: () => import('./views/ManageChannels.vue')
                },
                {
                    path: ':id/announcements',
                    name: 'adminManage-announcements',
                    meta: {
                        title: 'Admin - Ogłoszenia',
                        allowed: ['admin'],
                        adminManage: true
                    },
                    component: () => import('./views/Announcements.vue')
                },
                {
                    path: ':id/teleport',
                    name: 'adminManage-teleport',
                    meta: {
                        title: 'Admin - Teleport',
                        allowed: ['admin'],
                        adminManage: true
                    },
                    component: () => import('./views/Teleport.vue')
                },
                {
                    path: ':id/premium-pokes',
                    name: 'adminManage-premiumPokes',
                    meta: {
                        title: 'Admin - Zaczepki',
                        allowed: ['admin'],
                        adminManage: true
                    },
                    component: () => import('./views/PremiumPokes.vue')
                },
                {
                    path: ':id/access',
                    name: 'adminManage-access',
                    meta: {
                        title: 'Admin - Dostęp do panelu',
                        allowed: ['admin'],
                        adminManage: true
                    },
                    component: () => import('./views/Access.vue')
                },
            ]
        },
        {
            path: '/announcements',
            name: 'announcements',
            meta: {
                title: 'Ogłoszenia',
                allowed: ['premium']
            },
            component: () => import('./views/Announcements.vue')
        },
        {
            path: '/teleport',
            name: 'teleport',
            meta: {
                title: 'Teleport',
                allowed: ['premium']
            },
            component: () => import('./views/Teleport.vue')
        },
        {
            path: '/premium-pokes',
            name: 'premiumPokes',
            meta: {
                title: 'Zaczepki',
                allowed: ['premium']
            },
            component: () => import('./views/PremiumPokes.vue')
        },
        {
            path: '/home',
            name: 'home',
            meta: {
                title: 'Home',
                allowed: ['premium', 'admin']
            },
            component: () => import('./views/Home.vue')
        },
    ]
});

router.beforeEach((to, from, next) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const premiumChannel = localStorage.getItem('premiumChannel');
    const pagesEnabled = JSON.parse(localStorage.getItem('pagesEnabled'));

    document.title = "Lider » " + to.meta.title;

    if (to.meta.allowed.includes("public"))
        return next();

    if (pagesEnabled && typeof pagesEnabled[to.name] !== 'undefined' && pagesEnabled[to.name] === false)
        return next({name: 'home'});

    if ((to.meta.allowed.includes("premium") || to.meta.allowed.includes("admin") || to.meta.allowed.includes("premiumOwner")) && !user)
        return next({name: 'login'});

    if ((to.meta.allowed.includes("premium") && premiumChannel) || (to.meta.allowed.includes("admin") && user.isAdmin) || (to.meta.allowed.includes("premiumOwner") && premiumChannel && user.isOwner))
        return next();

    next({name: 'profile'});
});